<template>
  <div class="colorful-background wrapper-grid special">
    <div :class="['img', { animate__animated: isFirst }, ' animate__fadeIn']">
      <image-box class="image-box-position" img-u-r-l="/pic/2.png"></image-box>
    </div>

    <div
      :class="['title', { animate__animated: isFirst }, ' animate__flipInX']"
    >
      <span class="middle-font">您本学期共选</span>
      <span class="big-font"
        >{{ select_select.Number }}<span class="middle-font">门课</span>
      </span>
    </div>

    <div :class="['text', { animate__animated: isFirst }, ' animate__fadeIn']">
      <span class="small-font is-block">
        其中
      </span>
      <div
        style="
          width: 100%;
          justify-content: space-between;
          flex-wrap: wrap;
          display: flex;
        "
      >
        <div v-for="(value, key) in select_select.Type" v-bind:key="key">
          <span class="small-font" style="margin: 5px 10px 5px 0;">
            {{ value.Code }}类课{{ value.Num }}门
          </span>
        </div>
      </div>
    </div>

    <div
      :class="[
        'slogan',
        { animate__animated: isFirst },
        'animate__fadeIn',
        'big-margin-top',
      ]"
    >
      <span class="small-font">{{ slogan }}</span>
    </div>

    <div class="footer middle-margin-bottom">
      <div class="very-small-font">
        选课数据由杭电教务处提供
      </div>
      <span class="very-small-font">数据仅供参考</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'

export default {
  name: 'selectPage',
  components: { ImageBox },
  data() {
    return {
      slogan: '就算课程少，也不可以松懈学习哦',
      sloganList: [
        '就算课程少，也不可以松懈学习哦',
        '是一个繁忙的学期，幸苦了',
      ],
    }
  },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  computed: {
    select_select: function () {
      return store.state.$data.data.Select.Select
    },
  },
  mounted() {
    let tempNum = this.select_select.Number
    if (tempNum < 8) {
      this.slogan = this.sloganList[0]
    } else {
      this.slogan = this.sloganList[1]
    }
  },
}
</script>

<style scoped>
.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.title.animate__animated {
  animation-delay: var(--first-delay);
  /*animation-duration: var(--defalut-continue);*/
}

.text.animate__animated {
  animation-delay: var(--second-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}

.wrapper-grid.special {
  --first-color: var(--eggplant-purple);
  --page-background-color: var(--hduhelp-blue);
  --second-color: var(--beautiful-blue);
  grid-template-rows: 5vh repeat(4, minmax(auto, auto)) 1fr 5vh;
  grid-template-areas:
    '. .      .'
    '. title  .'
    '. img    .'
    '. text   .'
    '. slogan .'
    '. .      .'
    '. footer .';
}
</style>
